import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=31b4f0cc&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageSnapshotsCardInner: require('/usr/src/motec/components/page/snapshots/CardInner.vue').default})
